import srcLogo from "../assets/logo.png";
import srcHomeBackground from "../assets/background2.jpg";
import srcAboutBackground from "../assets/03.jpg";
import srcContactBackground from "../assets/contact.jpg";

import srcProduct3 from "../assets/01.jpg";
import srcProduct1 from "../assets/02.jpg";
import srcProduct2 from "../assets/mbr-6.jpg";

export const logo = srcLogo;

export const images = {
  homeBackground: srcHomeBackground,
  aboutBackground: srcAboutBackground,
  contactBackground: srcContactBackground,
  product1: srcProduct1,
  product2: srcProduct2,
  product3: srcProduct3,
};
